
import axios from 'axios'
import { JWT_TOKEN } from '../../constants'
const ReadAxios = async function (props = {}) {
    let userId = localStorage.getItem('userId') 
    let customerNo = localStorage.getItem('customerNo')
    let gett = localStorage.getItem("apiToken");
    let congData = JSON.stringify
        ({
            customerNo: +customerNo,
            customer_no: +customerNo,
            userId: +userId,
            ...props.readItems
        })
    const apiURL = props.completeURL ? `${props.completeURL}` : `${process.env.REACT_APP_MAIN_URL}/${props.url}`
    const token = JWT_TOKEN
    const publicURL = `${props.publicURL}`

    if (props.publicURL) {
        try {
            return new Promise((resolve, reject) => {
                var config = {
                    url: publicURL
                };
                axios(config)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        } catch (error) {
            return console.log('errorRead', error)
        }
    }
    else if (props.completeURL) {
        try {
            return new Promise((resolve, reject) => {
                var config = {
                    url: apiURL,
                    headers: {
                        Authorization: `${gett}`,
                        "Content-Type": "application/json",
                        "Access-Control-Allow-Origin": "*"
                    },
                    data: congData,
                    params: {
                        customer_no: +customerNo,
                        user_id: +userId,
                        customerNo: +customerNo,
                    }
                };

                axios(config)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        } catch (error) {
            return console.log('errorRead', error)
        }
    } else if (props.masterURL) {
        // console.log(props.masterURL)
        var payload, body;
        if (props.transporterId) {
            payload = {
                "customerNumber": 1158,
                "userId": 1,
                "customerNo": 1158,
                "id": props.transporterId
            }
        }
        else {
            payload = {
                "customerNumber": 1158,
                "userId": 1,
                "customerNo": 1158
            }
        }
        body = JSON.stringify
            ({
                "customerNumber": 1158,
                "userId": 1,
                ...props.bodyItems
            })

        try {
            return new Promise((resolve, reject) => {
                var config = {
                    method: props.method,
                    url: props.masterURL,
                    headers: {
                        Authorization: `${token}`,
                        "Content-Type": "application/json",
                    },
                    params: payload,
                    data: body
                };

                axios(config)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        } catch (error) {
            return console.log('err', error)
        }
    }
    else {
        try {
            // console.log(props.completeURL)
            return new Promise((resolve, reject) => {
                axios.post(apiURL, congData, {
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': `${gett}`,
                    },
                }).then((res) => {
                    if (res.data.status === 200 && res.data.resultSet !== '') {
                        resolve(res);
                    } else {
                        reject(res)
                    }
                }).catch((err) => {
                    reject(err)
                })
            })
        } catch (error) {
            return console.log('err', error)
        }
    }
}

export default ReadAxios
